import { gql, useMutation } from "@apollo/client";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Graph } from "../../../../generated/graph";
import { AdsCampaignField } from "./AdsCampaignField";

interface Props {
  show: boolean;
  onToggle: (e: boolean) => void;
  data: Graph.SellerAdsCampaign;
  onComplete: (err: string) => void;
}

const MUTATTION_CREATE_SELLER_ITEM = gql`
  mutation createSellerAdsCampaignItem($campaignId: Int!, $data: SellerAdsCampaignItemInput!) {
    createSellerAdsCampaignItem(campaignId: $campaignId, data: $data)
  }
`;

export function AdsCampaignAddMore(props: Props) {
  const [items, setItems] = useState<any[]>([{}]);
  const [createSellerAdsCampaignItem, { loading }] = useMutation(MUTATTION_CREATE_SELLER_ITEM, {
    refetchQueries: ["sellerAdsCampaigns", "sellerAdsCampaign"],
    onError: (err) => {
      props.onComplete(err.message);
    },
  });

  const handlerClick = () => {
    for (let i = 0; i < items.length; i++) {
      const id = document.getElementById("product" + i);
      const biding: any = document.getElementById("biding" + i);
      const budget: any = document.getElementById("budget" + i);
      const type = document.getElementById("type" + i);

      createSellerAdsCampaignItem({
        variables: {
          campaignId: Number(props.data.id),
          data: {
            productId: Number(id!.innerHTML),
            biding: Number(biding.value),
            budget: Number(budget.value),
            type: type!.innerHTML,
          },
        },
      });
    }
    props.onComplete("");
  };

  return (
    <Modal show={props.show} onHide={() => props.onToggle(false)} centered size="lg">
      <Modal.Header closeButton translate="yes" onAuxClick={() => {}} onAuxClickCapture={() => {}}>
        <Modal.Title>{props.data.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Product Code</th>
              <th>Biding</th>
              <th>Budget</th>
              <th>Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((x: any, i: number) => {
              return (
                <AdsCampaignField
                  id={i + ""}
                  key={i}
                  data={x}
                  isAdd={i === items.length - 1}
                  onAdd={() => {
                    setItems([...items, {}]);
                  }}
                  onRemove={() => {
                    setItems(items.filter((item, index) => index !== i));
                  }}
                />
              );
            })}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-primary" onClick={handlerClick} disabled={!!loading}>
          Submit
        </button>
      </Modal.Footer>
    </Modal>
  );
}
